import { css, Inline, styled } from 'canoe';
import React from 'react';

import { ValueBox, ValueToggle } from '@candu-ai/craft/ui';
import { SizeType } from 'craft/components/Size';

const StyledValueBox = styled(ValueBox)<{ isLast?: boolean; standalone?: boolean }>`
  ${({ isLast, standalone }) => css`
    border-radius: 0;

    > div > div:first-of-type {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left-width: 0;
    }

    ${!standalone &&
    css`
      > div > div:last-of-type {
        ${isLast
          ? css`
              border-top-right-radius: 0;
            `
          : css`
              border-bottom-right-radius: 0;
            `}
      }
    `}
  `}
`;

interface Props {
  value?: SizeType;
  onChange: (v: SizeType) => void;
  isLast?: boolean;
  'data-cy'?: string;
  standalone?: boolean;
  showAuto?: boolean;
  showPercentage?: boolean;
  property: 'min' | 'max' | 'normal' | 'gap' | 'spacing';
}

export const SizeTypeSelector = ({
  value,
  onChange,
  isLast,
  'data-cy': dataCy = 'toolbox',
  standalone,
  showAuto,
  showPercentage = true,
  property,
}: Props) => {
  return (
    <Inline space="none">
      <StyledValueBox isLast={isLast} standalone={standalone}>
        <ValueToggle
          toggleGroup={`${dataCy}-sizeType`}
          id={`${dataCy}-${property}-px`}
          data-cy={`${dataCy}-px`}
          onClick={() => onChange(SizeType.Pixel)}
          isActive={value === SizeType.Pixel}
          label="px"
        />
        {showPercentage && (
          <ValueToggle
            toggleGroup={`${dataCy}-sizeType`}
            id={`${dataCy}-${property}-percentage`}
            data-cy={`${dataCy}-percentage`}
            onClick={() => onChange(SizeType.Percentage)}
            isActive={value === SizeType.Percentage}
            label="%"
          />
        )}
        {showAuto && (
          <ValueToggle
            toggleGroup={`${dataCy}-sizeType`}
            id={`${dataCy}-${property}-auto`}
            data-cy={`${dataCy}-auto`}
            onClick={() => onChange(SizeType.Auto)}
            isActive={value === SizeType.Auto}
            label="Auto"
          />
        )}
      </StyledValueBox>
    </Inline>
  );
};
